export default "__VITE_ASSET__DswO1a3A__"